import { render, staticRenderFns } from "./DashboardSelection.vue?vue&type=template&id=5fd0394b&scoped=true"
import script from "./DashboardSelection.vue?vue&type=script&lang=js"
export * from "./DashboardSelection.vue?vue&type=script&lang=js"
import style0 from "./DashboardSelection.vue?vue&type=style&index=0&id=5fd0394b&prod&scoped=true&lang=css"
import style1 from "./DashboardSelection.vue?vue&type=style&index=1&id=5fd0394b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd0394b",
  null
  
)

export default component.exports